// eslint-disable-next-line import/prefer-default-export
export const SESSION_DETAILS_MODAL_ISLAND = {
  SERVER_TYPE: 'Server Type',
  SERVER: 'Server',
  SERVER_TYPE_PLACEHOLDER: 'Select the server type',
  IP_PLACEHOLDER: 'Enter the system DNS host name or IP address',
  PORT_INPUT_PLACEHOLDER: 'Please enter a port number from 0-65353',
  PORT_NUMBER: 'Port Number',
  CANCEL: 'Cancel',
  LAUNCH: 'Launch',
  LAUNCH_SESSION: 'Launch Session',
  MODAL_ISLAND_SUBHEADING:
    'Specify the connection details of the remote system for this session.',
  SECONDARY_IP_CRIT_MESSAGE: 'Please provide a valid name or IP address',
  SECONDARY_PORT_CRIT_MESSAGE: 'Please enter a port number from 0-65353',
};
